module.exports = __webpack_public_path__ + "static/media/ski.53ce44a5.png";